import React from 'react';
import Axios from 'axios';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

import SeasonAdmin_nav from './SeasonAdmin_nav';
import TeamDropdownSeasonCfg from '../../shared/TeamDropdownSeasonCfg';
import QvneaBooksRegisterModal from '../customers/QvneaBooksRegisterModal';

const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const TABLE_NBCOL = 4;

const cstDefaultSortOrder = ['asc','desc', 'desc', 'asc'];

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

class SeasonAdmin_eqcfg extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			season: this.props.season,

			teams: [],
			teamIdx: 0,
			selectedTeam: { _id: "0", name: "", homeSite: "", players: [] },
			subTeamPlayers: [],

			newPlayerId: "-1",

			bypassDuplicatePlayerValidation: false,
			showQvneaBooksRegisterModal: false,
			modalData: {
				season: {
					_id: '0',
					leagueId: '0',
					name: '',
					playerCost: '0'
				},
				team: {
					_id: '0',
					name: '',
					players: []
				},
				statusMessage: ""
			},
      sortParams: {
				sortFieldIdx: 0,
				sortOrder: 'asc',
				sortClass: ['statelo-sorting_asc', '', '', '']
			},
			unsavedData: false,
			loadingTeam: true
		};
	
		this.loadTeamsPlayers = this.loadTeamsPlayers.bind(this);
		this.teamSectionWrapper = this.teamSectionWrapper.bind(this);
		this.createHomeSiteRow = this.createHomeSiteRow.bind(this);
		this.addPlayersSection = this.addPlayersSection.bind(this);
		this.teamPlayersTable = this.teamPlayersTable.bind(this);
		this.createPlayerRow = this.createPlayerRow.bind(this);

		this.handleSortPlayers = this.handleSortPlayers.bind(this);
		this.handleBypassDuplicatePlayerValidation = this.handleBypassDuplicatePlayerValidation.bind(this);
		this.handleTeamChange = this.handleTeamChange.bind(this);
		this.handleRemPlayer = this.handleRemPlayer.bind(this);
		this.handleTeamEdNameChange = this.handleTeamEdNameChange.bind(this);
		this.handleHomeSiteChange = this.handleHomeSiteChange.bind(this);
		this.handlePlayerChange = this.handlePlayerChange.bind(this);
		this.handleAddPlayerToTeam = this.handleAddPlayerToTeam.bind(this);
		this.handleSaveClick = this.handleSaveClick.bind(this);

		this.handleShowQvneaBooksRegisterModal = this.handleShowQvneaBooksRegisterModal.bind(this);
    this.handleQvneaBooksReloadData = this.handleQvneaBooksReloadData.bind(this);
    this.handleQvneaBooksModalCancel = this.handleQvneaBooksModalCancel.bind(this);
	}

 	componentDidMount() {
		console.log('SeasonAdmin_eqcfg: componentDidMount');
		this.loadTeamsPlayers(this.props.season, 0, this.state.sortParams);
	}

	componentDidUpdate(prevProps) {
	  if (prevProps !== this.props) {

	  	if (prevProps.season._id !== this.props.season._id) {
	  		// Avoid double teamloading spinner
	  		this.setState({loadingTeam: true});
	  	}

			//console.log('SeasonAdmin_eqcfg: componentDidUpdate');
			this.loadTeamsPlayers(this.props.season, 0, this.state.sortParams);
	 	}
	}

  loadTeamsPlayers(season, teamIdx, sortParams) {
    var _this = this;

  	console.log('loadTeamsPlayers')
  	console.time('LOADING')

		// season is empty on first renders when refreshing page (due to league change first with no season)
    if (season._id !== undefined) {

	    Axios.get('/api/teams/teamIdsBySeason/season/' + season._id).then(function (responseTeamIds) {
      Axios.get('/api/seasons/subPlayersTeam/' + season._id).then(function (responseSubPlayers) {

		  	console.timeEnd('LOADING')  // 13 sec for big leagues like QcInv
		  															// 1.3 sec if optionQvneaBooks = false

		  	//console.log('responseSubPlayers.data');
		  	//console.log(responseSubPlayers.data);

	      //var teams = responseTeams.data;
	      var teams = responseTeamIds.data;
			  var subTeamPlayers = responseSubPlayers.data;

			  // Push subplayers as last team
			  teams.push({
		      _id: "0",
		      name: 'Substituts',
			  });

			  _this.loadSelectedTeam(teams, teamIdx, function() {
			  	_this.setState({
				  	season: season,
				  	teams: teams,
				  	teamIdx: teamIdx,
				  	subTeamPlayers: subTeamPlayers,
						sortParams: sortParams
				  });
			  });
			});
			});
		}

  }

  loadSelectedTeam(teams, teamIdx, callback) {
    var _this = this;
		var optionQvneaBooks = (this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ? 'true' : 'false';
  	var selectedTeam = teams[teamIdx];

  	console.time('LOADING SELECTED TEAM')

		// Load selectedTeam players and details
    Axios.get('/api/teams/' + selectedTeam._id + '/seasonId/' + _this.state.season._id + 
    	'/extended2/' + optionQvneaBooks).then(function (responseTeam) {
	  	selectedTeam = responseTeam.data;

	  	// console.log('selectedTeam')
	  	// console.log(selectedTeam)

		  // Modal Data
			var modalData = {
				season: _this.state.season,
				team: {
					_id: selectedTeam._id,
					name: selectedTeam.name,
					players: selectedTeam.players
				},
				statusMessage: ""
			}

	  	console.timeEnd('LOADING SELECTED TEAM')

			_this.sortTeamPlayers(selectedTeam, _this.state.sortParams, function(selectedTeam) {
		  	_this.setState({
			  	selectedTeam: selectedTeam,
					modalData: modalData,
		  		newPlayerId: -1,
					loadingTeam: false
			  }, callback());
			});
		});
  }

  sortTeamPlayers(selectedTeam, sortParams, callback) {
		var sortSign = 1;
		if (sortParams.sortOrder === 'desc') { 
			sortSign = -1; 
		}

		if (selectedTeam.players.length !== 0) {

	  	selectedTeam.players.sort((a, b) => {

	  		var compVal = 0;
	  		switch(sortParams.sortFieldIdx) {
	  			case 0:
						compVal = sortSign * a.name.localeCompare(b.name);
	  				break;
	  			case 1:
						if ((a.qvneaBooks !== undefined) && (b.qvneaBooks !== undefined)) {
							compVal = sortSign * (a.qvneaBooks.inscriptionsCount - b.qvneaBooks.inscriptionsCount);
							if (compVal === 0) {
								compVal = sortSign * (a.qvneaBooks.inscriptionsTotal - b.qvneaBooks.inscriptionsTotal);
							}
						}
	  				break;
	  			case 2:
						if ((a.qvneaBooks !== undefined) && (b.qvneaBooks !== undefined)) {
							compVal = -sortSign * (a.qvneaBooks.mccInscriptions - b.qvneaBooks.mccInscriptions);
						}
	  				break;
	  		}

				// Results
				if (compVal !== 0) {
					return compVal;
				} else {
					return a.name.localeCompare(b.name);
				}
	  	});
		}

  	callback(selectedTeam);
	}

 	render() {
		//console.log('SeasonAdmin_eqcfg: RENDER');
		//console.log(this.props)
		//console.log(this.state);
		//console.log(this.state.selectedTeam);

		// Disable button if needed
		var qvneaBooksButtonDisabled = true;
		if (!this.state.unsavedData) {
			if (this.state.selectedTeam.players !== undefined) {
				if (this.state.selectedTeam.players.length !== 0) {
					qvneaBooksButtonDisabled = false;
				}
			}
		}

 		// Get last array element (subPlayers)
 		var nbTeams = this.state.teams.length;

    // ADMIN LEVEL REQUESTED:  03-SEASON
    if (this.props.adminAccess.adminValidatedAccessLevel > ADMIN_LVL_SCORESHEETS) {

      return (
        <div className="col-md-9">   {/*padding-left already set in parent*/} 
          <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
        </div>
      );
    } else {

			if(this.state.season._id === "0") {
        return (
	        <div className="col-md-9">   {/*padding-left already set in parent*/} 
            <p>Vous devez d'abord créer une saison pour cette ligue dans l'onglet Ligue</p>
          </div>
        );

			} else {

				return (
          <div>
        		<SeasonAdmin_nav adminAccess={this.props.adminAccess} season={this.state.season} />

          	<div className="row">
          	<div className="col-md-12">
							<h5>Composition des équipes et substituts</h5>
							<p>Choisir une équipe et insérer les joueurs appropriés dans l'équipe.<br/>
								Pour insérer un subtitut, sélectionner l'équipe "Substituts".<br/>
								<i>Ne pas oublier de sauvegarder vos changements !</i><br/>
							</p>

							<p className="small-margin"><strong>Options</strong></p>

							<label className="switch switch-3d switch-sm switch-success form-control-label">
								<input type="checkbox" className="switch-input form-check-input" 
									checked={this.state.bypassDuplicatePlayerValidation || false} onChange={this.handleBypassDuplicatePlayerValidation}/>
								<span className="switch-label"></span>
								<span className="switch-handle"></span>
							</label>
							&nbsp;&nbsp;Désactiver les avertissement (ajout de joueur en double ou retrait de joueur)
							<br/><br/>

							<div className="row">
            	<div className="col-md-6">
            		<label htmlFor="teamSelect"><strong>Choisir une équipe</strong></label>
                <TeamDropdownSeasonCfg id="teamSelect" value={this.state.teamIdx} teams={this.state.teams}
									teamChange={this.handleTeamChange}/>
							</div>

            	<div className="col-md-6">
							</div>

							</div>
						<br/>

						<div className="row">
							{(nbTeams !== 0) ? this.teamSectionWrapper() : null}
						</div>

						<div className="row">
						<div className="col-12">
							{(this.state.unsavedData) ? <p><i> Donnnées non-sauvegardées </i></p> 
							: null}
							<button type="submit" className="btn btn-primary btn-margin-right-20" onClick={this.handleSaveClick}>
								Sauvegarder
							</button>

							{(this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
								<button type="button" className="btn btn-qvnea" disabled={qvneaBooksButtonDisabled} 
									onClick={this.handleShowQvneaBooksRegisterModal}>
									QVNEA Books
								</button>
							: null}
						</div>
						</div>
						<br/>

          	</div>
          	</div>

						{/* Modal */}
						<QvneaBooksRegisterModal 
							className = {this.props.className}
							showModal = {this.state.showQvneaBooksRegisterModal}
							modalData = {this.state.modalData}
							handleQvneaBooksReloadData = {this.handleQvneaBooksReloadData}
							handleQvneaBooksModalCancel = {this.handleQvneaBooksModalCancel}
							user = {this.props.profile.name}
						/>
          </div>
        );
			}
		}
  }

  teamSectionWrapper() {
		return (
			<div className="col-md-6">
				<p><strong>Paramètres de l'équipe</strong></p>
				{(this.state.loadingTeam) ? 
					this.displaySpinner()	: 
					this.teamSection()
				}
			</div>
  	);
  }

  teamSection() {
		var selectedTeam = this.state.selectedTeam;
  	var teamIdTxt = "Nom de l'équipe";
  	var isSubTeam = (selectedTeam._id === "0");
  	if (isSubTeam) {
  		teamIdTxt = "Substituts";
  	}

  	return(
			<div className="card">
			<div className="card-block">

				<div className="row row-margin-bottom-10">
				<div className="col-md-12">
					<span>{teamIdTxt}</span>
					{!isSubTeam ?
						<input className="form-control form-control-sm" type="text" id="teamEdName"
							value={selectedTeam.name} onChange={this.handleTeamEdNameChange}/>
						: null}
 				</div>
 				</div>

				{!isSubTeam ? this.createHomeSiteRow(): null}
 				
				<div className="row">
				<div className="col-md-12">
	 				{this.addPlayersSection()}
	 			</div>
	 			</div>

				<div className="row">
				<div className="col-md-12">
	 				{this.teamPlayersTable()}
	 			</div>
 				</div>

 			</div>
			</div>
		)
  }

  createHomeSiteRow() {
		var selectedTeam = this.state.selectedTeam;

  	return (
			<div className="row row-margin-bottom-10">
			<div className="col-md-12">
		  	<span> Domicile </span>
		  	<input className="form-control form-control-sm" type="text" id="homeSite"
		  		value={selectedTeam.homeSite} onChange={this.handleHomeSiteChange}/>
 			</div>
 			</div>
    );
  }

  addPlayersSection() {
  	return (
  		<div className="control-group">
			<div className="row">
			<div className="col-md-12">
				<span>Ajouter un joueur</span>

				<div className="row">
				<div className="col-9 row-margin-bottom-10">
					<AutoSuggestPlayer /*theme={autoSuggTheme}*/ playerId={this.state.newPlayerId} 
						dataChange={this.handlePlayerChange} option="1"/>
				</div>
				<div className="col-3">
					<button type="button" id='addbutton' className="btn btn-primary btn-addPlayer" 
						onClick={this.handleAddPlayerToTeam}> +
					</button>
				</div>
				</div>
			</div>
			</div>
			</div>
		);
  }

  teamPlayersTable() {
		var selectedTeam = this.state.selectedTeam;
		var sortClass = this.state.sortParams.sortClass;

  	if (selectedTeam.players.length === 0) {
  		return (
				<table className="table table-striped table-hover table-sm">
				<thead>
	        <tr>
						<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortPlayers}> Joueurs	</th>
						<th></th>
  	      </tr>
				</thead>
				<tbody>
					<tr><td>Aucun joueur dans ce groupe</td><td></td></tr>
				</tbody>
				</table>
			);

  	} else {
    	return (
				<table className="table table-striped table-hover table-sm">
				<thead>
          <tr>
						<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortPlayers}> Joueurs	</th>
						{(this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
							<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortPlayers}> 
								QVNEA Ligue<br/>Inscriptions
							</th> : null
						}
						{(this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
							<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortPlayers}> 
								Carte de Membre<br/>Inscriptions
							</th> : null
						}
						<th></th>
	        </tr>
				</thead>
				<tbody>
					{selectedTeam.players.map(this.createPlayerRow)}
				</tbody>
				</table>
			);
    }
  }

  createPlayerRow(playerItem, playerIdx) {
  	var _this = this;

  	var inscriptionsTotal = 0;
  	var inscriptionsText = '';
  	var cmText = '';

  	if (playerItem.qvneaBooks !== undefined) {
  		inscriptionsTotal = playerItem.qvneaBooks.inscriptionsTotal;
			inscriptionsText = playerItem.qvneaBooks.inscriptionsCount + ' (' + 
				(-inscriptionsTotal).toFixed(2) + ' $)';
			cmText = (-playerItem.qvneaBooks.mccInscriptions).toFixed(2) + ' $'; 
  	}

		return (
			<tr key={'plid.' + playerIdx}>
			<td>{playerItem.name}</td>

			{(this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
				<td>{inscriptionsText}</td>
				: null
			}
			{(this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1) ?
				<td>{cmText}</td>
				: null
			}

      <td className="text-right">
      	<span className="btn-sm2 trashIcon1" id={'remPlayer.' + playerIdx} 
      		onClick={this.handleRemPlayer.bind(this, playerIdx, inscriptionsTotal)}>
      		<i className="fa fa-trash-o"></i>
      	</span>
      </td>
      </tr>
		)
	}

	handleSortPlayers(e) {
		var _this = this;
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[colIdx];
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

	  _this.sortTeamPlayers(_this.state.selectedTeam, sortParams, function(selectedTeam) {
	  	_this.setState({
		  	selectedTeam: selectedTeam,
				sortParams: sortParams
		  });
	  });
	}

	// ------------------------------------------------------------------------------
	handleBypassDuplicatePlayerValidation(e) {
		this.setState({
			bypassDuplicatePlayerValidation: !this.state.bypassDuplicatePlayerValidation
		});			
	}

  handleTeamChange(e) {
  	var _this = this;
  	var teamIdx = parseInt(e.target.value, 10);
  	var teams = this.state.teams;

		_this.setState({
			teamIdx: teamIdx,
			loadingTeam: true
		}, _this.loadSelectedTeam(teams, teamIdx, function() {}) );
	}

	handleTeamEdNameChange(e) {
		var elemInfo = e.target.id.split(".");
		var tIdx = parseInt(elemInfo[1]);
		var selectedTeam = this.state.selectedTeam;
		selectedTeam.name = e.target.value;

		this.setState({
			selectedTeam: selectedTeam,
			unsavedData: true
		});		
	}

	handleHomeSiteChange(e) {
		var elemInfo = e.target.id.split(".");
		var tIdx = parseInt(elemInfo[1]);
		var selectedTeam = this.state.selectedTeam;
		selectedTeam.homeSite = e.target.value;

		this.setState({
			selectedTeam: selectedTeam,
			unsavedData: true
		});
	}

  handlePlayerChange(dataValue) {
		// console.log('handlePlayerChange')
		// console.log(dataValue)
		var newPlayerId = this.state.newPlayerId;
		newPlayerId = dataValue;
		this.setState({
			newPlayerId: newPlayerId,
		});
  }

	handleAddPlayerToTeam(e) {
		var _this = this;
		var newPlayerId = this.state.newPlayerId;
		var selectedTeam = this.state.selectedTeam;

		// Must choose a player
		if ((newPlayerId === 0) || (newPlayerId === undefined) || (newPlayerId === '-1')) {
			alert('Vous devez d\'abord choisir un joueur');
			return;
		}

		Axios.post('/api/teams/eqcfgAddPlayer/', {
			seasonId: _this.state.season._id,
			teamId: selectedTeam._id,
			playerId: newPlayerId,
			skipValidation: false
		})
		.then(function(response) {
			var respMsg = response.data;
			if (respMsg !== "OK") {
				var addPlayerOK = true;
				if(!_this.state.bypassDuplicatePlayerValidation && (respMsg === "existingInSubs")) {
					addPlayerOK = window.confirm("Ce joueur existe déjà dans les substituts, " +
						"cliquer OK pour l'ajouter dans cette équipe également");
				}
				if (respMsg === "existingInThisTeam") {
					alert('Sélection non-valide: ce joueur existe déjà dans cette équipe');
					addPlayerOK = false;
				}
				if (!_this.state.bypassDuplicatePlayerValidation && (respMsg === "existingInAnotherTeam")) {
					// alert('Sélection non-valide: ce joueur existe déjà dans une équipe');
					addPlayerOK = window.confirm("Ce joueur existe déjà dans une autre équipe, " +
						"cliquer OK pour l'ajouter dans cette équipe également");
				}

				// Add player validation done
				if (addPlayerOK) {
					Axios.post('/api/teams/eqcfgAddPlayer/', {
						seasonId: _this.state.season._id,
						teamId: selectedTeam._id,
						playerId: newPlayerId,
						skipValidation: true
					})
					.then(function(response) {
						_this.loadSelectedTeam(_this.state.teams, _this.state.teamIdx, function() {});
					})
					.catch(function(error) {
						console.log(error);
					});
				}
			} else {
				_this.loadSelectedTeam(_this.state.teams, _this.state.teamIdx, function() {});
			}
		})
		.catch(function(error) {
			console.log(error);
		});
	}

	handleRemPlayer(pIdx, inscriptionsTotal) {
		var _this = this;
		var selectedTeam = this.state.selectedTeam;
		var playerId = selectedTeam.players[pIdx].playerId;

		var validateRemovePlayer = true;
		var skipFinalValidation = false;
		var qvneaAdmin = (this.props.adminAccess.charterAdmin.indexOf('QVNEA-MASTER') !== -1);

		// Check QVNEA Admin: can't remove player without QVNEA access if player has inscriptions in Qvnea Books
		if (inscriptionsTotal !== 0) {
			if (!qvneaAdmin) {
				alert("Vous ne pouvez pas retirer ce joueur parce que son inscription est comptabilisée dans les fichiers de finances de la QVNEA.\n" + 
					"Contactez Pascal Grenier pour qu'il retire le joueur.")
				validateRemovePlayer = false;
			} else {
				validateRemovePlayer = false;
				if (window.confirm("Attention, ce joueur a une entrée inscription dans les finances de la QVNEA. " + 
					"Cliquer sur OK pour le retirer de l'équipe quand même.")) {

					validateRemovePlayer = true;
					skipFinalValidation = true;
				}
			}
		}

		// Ready to remove player, final validation first, if not skipped
		if (validateRemovePlayer) {
			var finalValidationRemovePlayer = true;

			if (!skipFinalValidation) {
		    finalValidationRemovePlayer = window.confirm('Retirer ce joueur: ' + selectedTeam.players[pIdx].name + 
	  	  	'\nCliquer sur OK pour confirmer');
			}

			if (finalValidationRemovePlayer) {

				Axios.post('/api/teams/eqcfgRemovePlayer/', {
					seasonId: _this.state.season._id,
					teamId: selectedTeam._id,
					playerId: playerId,
				})
				.then(function(response) {
					_this.loadSelectedTeam(_this.state.teams, _this.state.teamIdx, function() {});
				})
				.catch(function(error) {
					console.log(error);
				});
			}
		}

	}

	handleShowQvneaBooksRegisterModal() {
  	this.setState({	showQvneaBooksRegisterModal: true });
	}

	handleQvneaBooksReloadData() {
		this.loadTeamsPlayers(this.state.season, this.state.teamIdx, this.state.sortParams);
	}

	handleQvneaBooksModalCancel() {
		var modalData = this.state.modalData;
		modalData.statusMessage = "";
		this.setState({ modalData: modalData, showQvneaBooksRegisterModal: false });
		this.loadTeamsPlayers(this.state.season, this.state.teamIdx, this.state.sortParams);
	}

 	handleSaveClick() {
 		// console.log('SeasonAdmin_eqcfg: handleSaveClick');
		var _this = this;
		
		//console.log('SAVING TEAM')
		//console.log(this.state.selectedTeam)

		// remove players field (destructuration)
		const {players, ...teamWithoutPlayers} = this.state.selectedTeam;

		// TEAMS (only one now)
		Axios.post('/api/teams/updateOneTeam', {
			teamData: teamWithoutPlayers
		})
		.then(function(response) {
			_this.setState({ unsavedData: false});
			_this.loadTeamsPlayers(_this.state.season, _this.state.teamIdx, _this.state.sortParams);
		})
		.catch(function(error) {
			console.log(error);
		});
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default SeasonAdmin_eqcfg;

